import React from 'react';
import PropTypes from 'prop-types';
import {Subheader, Paper} from 'material-ui';
import style from '../../../../../styles/styles';
import Info from "../../../../common/Info/Info";
import withTranslation from "../../../../../hoc/withTranslation";

const Timestamp = require('react-timestamp');

class MediaTypeInfo extends React.Component {
    static propTypes = {
        mediaType: PropTypes.object.isRequired
    };

    render() {
        return (
            <Paper>
                <Subheader style={style.subHeader}>{this.props.t('generic.information')}</Subheader>
                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={this.props.mediaType.id}
                    />
                    <Info
                        title={this.props.t('generic.name')}
                        content={this.props.mediaType.name}
                    />
                    <Info
                        title={this.props.t('generic.color')}
                        content={this.props.mediaType.color}
                    />
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={this.props.mediaType.created_at} format='full' twentyFourHour/>}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            this.props.mediaType.updated_at &&
                            <Timestamp time={this.props.mediaType.updated_at} format='full' twentyFourHour/>
                        ) || this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
            </Paper>
        )
    };
}

export default withTranslation(MediaTypeInfo);



// WEBPACK FOOTER //
// src/components/media/MediaType/MediaTypeFull/MediaTypeInfo/MediaTypeInfo.js